import styled from "styled-components";
import { Switch } from "antd";

export const StyledSwitch = styled(Switch)`
  &.ant-switch.ant-switch-checked {
    background: #00aeef;
  }
`;
